module.exports = __webpack_public_path__ + "media/src/images/icon/calendar-87a40e4d34a9ad8f46d7dc14382e1452.svg";